import { useEffect } from "react";

export default function AppointmentSuccess() {
  useEffect(() => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "conversion", {
        send_to: "AW-17685944295/2yFlCOzW370bE0evqPFB",
      });
    }
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-100 flex flex-col">
      <section className="flex-1 flex flex-col justify-center items-center text-center px-6 pb-60 bg-gradient-to-b from-white to-blue-100">
        <div className="w-full max-w-2xl bg-white dark:bg-gray-800 rounded-2xl shadow-2xl p-6 sm:p-8 transform transition-all duration-300 scale-100 hover:scale-[1.01] flex flex-col items-center text-center space-y-4">
          <p className="text-sm sm:text-lg text-gray-500 dark:text-gray-400">
            Your booking request has been submitted! We have sent your appointment details to the business for final confirmation.
          </p>

          <p className="text-sm sm:text-lg text-gray-500 dark:text-gray-400">
            We’re looking forward to supporting your wellness journey.
          </p>

          <p className="text-sm sm:text-lg text-gray-500 dark:text-gray-400">
            A confirmation email with your appointment details will be sent to
            your inbox.
          </p>

          <p className="text-sm sm:text-lg text-gray-500 dark:text-gray-400">
            For any queries or information, contact us at{" "}
            <a
              href="mailto:info@lastminutewellness.ca"
              className="text-blue-600 underline"
            >
              info@lastminutewellness.ca
            </a>
          </p>
        </div>
      </section>
    </div>
  );
}
